var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { axios } from "./axios";
import { HttpFormError } from "./HttpFormError";
var IndexModel = (function (_super) {
    __extends(IndexModel, _super);
    function IndexModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.page = 1;
        _this.filters = {};
        _this.prefix = '/api/';
        _this.data = false;
        _this.selected = false;
        return _this;
    }
    IndexModel.prototype.load = function (append) {
        if (append === void 0) { append = false; }
        return this.loadIndex(this.endpoint, append);
    };
    IndexModel.prototype.getData = function () {
        if (this.data) {
            return this.data.data;
        }
        return [];
    };
    IndexModel.prototype.resetFilters = function () {
        return this.load();
    };
    IndexModel.prototype.loadIndex = function (endpoint, append) {
        var _this = this;
        if (append === void 0) { append = false; }
        if (!append) {
            this.page = 1;
            this.setLoading();
        }
        this.resetErrorStatus();
        var url = this.prefix + endpoint + this.buildQueryParameters();
        return axios.get(url)
            .then(function (response) {
            var responseData = response.data;
            _this.processIndexData(responseData, append);
        })
            .then(function () { return _this.setLoadingComplete(); })
            .catch(function (error) {
            _this.setError(error);
        });
    };
    IndexModel.prototype.processIndexData = function (response, append) {
        var _a;
        if (append === void 0) { append = false; }
        if (!this.data || !append) {
            this.data = response;
        }
        else {
            (_a = this.data.data).push.apply(_a, response.data);
        }
        return this.data;
    };
    IndexModel.prototype.buildQueryParameters = function () {
        var params = '?page=' + this.page;
        for (var key in this.filters) {
            var value = this.filters[key];
            if (value !== null) {
                params = params + '&' + key + '=' + value;
            }
        }
        return params;
    };
    IndexModel.prototype.hasResults = function () {
        return this.data && this.data.data.length > 0;
    };
    IndexModel.prototype.indexHasMoreResults = function () {
        if (this.data) {
            return this.data.meta && (this.page <= this.data.meta.last_page);
        }
        return false;
    };
    IndexModel.prototype.infiniteLoadingHandler = function ($state) {
        var _this = this;
        this.page += 1;
        return new Promise(function (resolve) {
            if (_this.indexHasMoreResults()) {
                _this.load(true).then(function () {
                    $state.loaded();
                });
            }
            else {
                $state.loaded();
                $state.complete();
            }
            resolve(true);
        });
    };
    IndexModel.prototype.isLoaded = function () {
        return this.loaded;
    };
    IndexModel.prototype.setLoading = function () {
        this.loaded = false;
    };
    IndexModel.prototype.setLoadingComplete = function () {
        this.loaded = true;
    };
    IndexModel.prototype.hasSelectedItem = function () {
        return this.selected !== false;
    };
    IndexModel.prototype.selectIndexItem = function (index, toggle) {
        if (toggle === void 0) { toggle = true; }
        if (toggle && this.selected === index) {
            this.selected = false;
        }
        else {
            this.selected = this.getData()[index];
        }
    };
    return IndexModel;
}(HttpFormError));
export { IndexModel };
